// extracted by mini-css-extract-plugin
export default {"icon--medium":"JQx4o1K","icon--small":"s_TsKbq"};